import EuFormContainer from 'components/eu/EuFormContainer';

export default function GbMigrationFormPage() {
  const contentfulId = '3P7kVSHvBzdvSGh927VXln'; // United Kingdom Form Page
  const country = 'UNITED KINGDOM';
  return <EuFormContainer contentfulId={contentfulId} country={country} />;
}
